<app-header></app-header>
<header class="slidermain menu-page text-white thanku-page"> 
    <img src="assets/img/thanku-bg.jpg" alt="news" class="w-100">
     <div class="container-fluid">
         <div class="mask-content-v-center text-left">
                   <div class="row align-items-center">
                      
                    <div class="col-md-5 mx-auto thanku-tbox-left">
                      <div class="border-out text-center">
                        <div class="right-check cross-check">
                          <i class="fas fa-times"></i>
                        </div>
                        <h3 class="thanku-heading"> {{ 'thankyou.pay_cancel' | translate }} </h3>
                        <div class="divider">
                           <span class="border"></span>
                          </div>
                          <p class="b-text">{{ 'thankyou.pay_notp' | translate }}</p>
                        <a class="download bckhpage-btn"  href="/" >{{ 'thankyou.back_home' | translate }}</a>
                        
                      </div>
                    </div>
                    
                   </div>
                   
                </div>
     </div>
</header>

